export default value => {
    if (!value || typeof value !== 'string') return '';
    return value.split('*').join('');
};
